import React from 'react'
import "./About.scss"
import CV from "../../assets/DenysSemkoCV.pdf";
import { motion } from "framer-motion";

const About = () => {
  return (
    <div className='about flex container'>
      <motion.div
        initial={{ y: '100%', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="images-container flex">
          <img src="/assets/avatar.png" alt="" className="avatar" />
      </motion.div>
      <motion.div
        initial={{ y: '100%', opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.6, ease: 'easeOut' }}
        className="description-container">
        <div className="title-container">
          <h1 className="title">
            Let's get to know me better
          </h1>
        </div>
        <div className="short-description">
          <p className='description'>
            I'm a Sofware Engineer based in Ukraine, who's experienced in .NET development and building applications from scratch to production. 
            My love for problem-solving drives me to create innovative solutions and contribute effectively to diverse projects.
          </p>
        </div>
        <div className="btn-container">
          <a href={CV} download><button className="download-btn">SEE MY CV</button></a>
        </div>
      </motion.div>
    </div>
  )
}

export default About